module.exports = __webpack_public_path__ + "media/images/wood-bg-1-38e5c286c0a0e1b63fad5864fb2124d7.jpg";